import axiosInstance from './interceptor'


//Get Inventory List based on Dispatch Location Id
export const getInventoryList = async (id: any) => {

    return await axiosInstance.get(`BottleOrder/GetBottleInventoryByDespatchLocationId/${id}`).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}

export const updateInventory = async (params: any) => {

    return await axiosInstance.put(`BottleOrder/UpdateBottleInventory`, params).then((res: any) => {
        return res
    }).catch((error: any) => {
        return error.response
    })
}